<template>
  <div id="trs-main">
    <h1 class="page-title title">{{ $t('history.title.history') }}</h1>
    <div class="page-ct">
      <div id="block-transaction-history">
        <div class="section">
          <h4 class="title">{{ $t('history.title.history2') }}</h4>
          <div class="box-ct">
            <div class="alert alert-success" v-if="model.successMessage">{{ $t(model.successMessage) }}</div>
            <div class="alert alert-danger" v-if="model.errorMessage" v-html="$t(model.errorMessage)"></div>
            <div class="box-filter">
              <form class="form-horizontal" id="exportCsv">
                <div class="form-group display-form">
                  <div class="col-md-4 col-12 nopadding-left nopadding-right">
                    <label class="labeltop">{{ $t('report.label.period') }}</label>
                    <div class="col-12 nopadding display-form">
                      <div class="col-5 nopadding" >
                        <trs-date-picker v-model="dateStart"
                                         :toDate="dateEnd"/>
                      </div>
                      <div class="col-2 nopadding d-flex justify-content-center align-items-center"><span>~</span></div>
                      <div class="col-5 nopadding">
                          <trs-date-picker v-model="dateEnd"
                                         :fromDate="dateStart"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 nopadding-left nopadding-right">
                    <label class="labeltop">{{ $t('history.label.transaction_type') }}</label>
                    <div class="col-12 col-12 nopadding display-form">
                      <dropdown-select classProps="HistoryType"
                                       :items="mapTransactionType"
                                       @onSelect="typeChange($event)"
                                       :translate=true
                                       :allowAll=true
                      >
                      </dropdown-select>
                    </div>
                  </div>
                  <div class="col-2 col-md-2 col-12 nopadding nopadding-right">
                    <label class="labeltop">{{ $t('history.label.status') }}</label>
                    <div class="col-12 col-12 nopadding display-form" v-if="isTypeChange">
                      <dropdown-select classProps="DepositStatus"
                                       :items="mapDepositStatus"
                                       @onSelect="historyCondition['condition.status'] = $event"
                                       :translate=true
                                       :allowAll=true
                      >
                      </dropdown-select>
                    </div>
                    <div class="col-12 col-12 nopadding display-form" v-else>
                      <dropdown-select classProps="TransferStatus"
                                       :items="mapTransferStatus"
                                       @onSelect="historyCondition['condition.transferStatus'] = $event"
                                       :translate=true
                                       :allowAll=true
                      >
                      </dropdown-select>
                    </div>
                  </div>
                  <div class="col-2 col-md-2 col-12 nopadding">
                    <div class="col-12 nopadding display-form" style="margin-top: 2px;">
                      <div class="col-6 nopadding-left">
                        <a href="#" id="btn-search" class="btn btn-success btn-block margintop"
                           @click="initHistory(true)">
                          {{ $t('btn.search') }}
                        </a>
                      </div>
                      <div class="col-6 nopadding">
                        <button type="button" class="btn btn-primary btn-block margintop"
                           @click="exportCsv" :disabled="isDisabled"
                           id="btnExportCsv">CSV</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="section">
        <div class="table-responsive">
          <table class="table table-bordered text-center table-hover table-striped table-font-sm">
            <thead>
            <tr>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.transactionId') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.type') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.amount') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.date') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.source') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.destination') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.status') }}</th>
              <th class="text-center">{{ $t('nts.ams.fe.label.history.table.header.cancel') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(transactionInfo, index) in model.listPaymentTransactionInfo" v-bind:key="index">
              <td>{{ transactionInfo.transactionId }}</td>
              <td>{{ $t(transactionInfo.typeName) }}</td>
              <td class="text-right">
                {{ transactionInfo.amountFrom | moneyFormat }}
                {{ transactionInfo.fromCurrencyCode | namingCurrency }}
              </td>
              <td>{{ transactionInfo.acceptTime }}</td>
              <td>{{ $t(transactionInfo.source) }}</td>
              <td>{{ $t(transactionInfo.destination) }}</td>
              <td>{{ $t(transactionInfo.statusStr) }}</td>
              <td v-if="(transactionInfo.status == 5 && (transactionInfo.type.indexOf('Deposit') > -1 || transactionInfo.type.indexOf('Withdrawal') > -1))">
                <a href="#" class="btn btn-xs btn-danger" @click="cancelWithdrawal(transactionInfo.transactionId)">
                  {{ $t('nts.ams.fe.label.history.table.header.cancel') }}
                </a>
              </td>
              <td v-if="!(transactionInfo.status == 5 && (transactionInfo.type.indexOf('Deposit') > -1 || transactionInfo.type.indexOf('Withdrawal') > -1))">
                -
              </td>
            </tr>
            <tr>
              <td colspan="11" v-if="model.infoMessage !== null" class="nodata">
                {{ $t(model.infoMessage) }}
              </td>
            </tr>
            </tbody>

          </table>
        </div>
        <nav class="text-center" v-if="model.listPaymentTransactionInfo && model.listPaymentTransactionInfo.length !== 0">
          <Pagination
              :total-pages="totalPage"
              :total="totalItems"
              :per-page="offset"
              :current-page="currentPage"
              @pagechanged="onPageChanged"
              @pageJump="onPageJump"
              :previousText="$t('navigation.bt.previous')"
              :nextText="$t('navigation.bt.next')"
              :firstText="$t('navigation.bt.first')"
              :lastText="$t('navigation.bt.last')"
          ></Pagination>
        </nav>
      </div>
      </div>
      <div id="block-login-history">
        <LoginHistory />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Pagination from "@/components/base/Pagination";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import {MENU_HOME, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
import {createNamespacedHelpers} from "vuex";
import $ from "jquery";
import offModalEvent from "@/common/mixins/offModalEvent";
import Config from "@/services/Config";
import {ROOT, HISTORY} from "@/services/modules/_base";
import LoginHistory from "@/views/index/history/LoginHistory";

const domain = Config.getDomain();
const {mapActions: mapHeaderActions} = createNamespacedHelpers("header");

export default {
  components: {LoginHistory, Pagination},
  data() {
    return {
      mapTransactionType: this.IConstants.getMapTransactionType(),
      mapTransactionMethod: this.IConstants.getMapTransactionMethod(),
      mapDepositStatus: this.IConstants.getMapDepositStatus(),
      mapTransferStatus: this.IConstants.getMapCashBackStatus(),
      historyCondition: {
        'condition.status': '-1',
        'condition.transferStatus': '-1',
        'condition.transactionType': '-1',
        'condition.fromDate': moment(new Date(new Date().getTime() - 1000 * 60 * 60 * 24)).format('YYYY/MM/DD'),
        'condition.toDate': moment(new Date()).format('YYYY/MM/DD'),
      },
      model: {},
      totalPage: 0,
      totalItems: 0,
      offset: 0,
      currentPage: 1,
      isTypeChange: true,
      isDisabled: false,
      wid: null,
      WITHDRAWAL_SERVICE: 'withdrawal',
      messageConfirm: '',
      dateStart: moment(new Date(new Date().getTime() - 1000 * 60 * 60 * 24)).format('YYYY/MM/DD'),
      dateEnd: moment(new Date()).format('YYYY/MM/DD'),
      depositStatus: '-1',
      transferStatus: '-1',
    }
  },
  mixins: [offModalEvent],

  created() {
    this[SET_ACTIVE_TAB_ID](MENU_HOME);
    this.initHistory(true);
  },
  mounted() {
    $(window).bind("pageshow", function(event) {
      if (event.originalEvent.persisted) {
        window.location.reload();
      }
    });
    $('.mx-datepicker').removeClass("col")
      
    $('.input-group .form-control').css('padding-right', '0');

    this.getModalConfirmResult();
  },
  destroyed() {
    this.offEventName(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.HISTORY_CANCEL);
  },
  methods: {
    ...mapHeaderActions([
      SET_ACTIVE_TAB_ID
    ]),
    formatDate(dateStart, dateEnd) {
      if (dateStart == null) {
        this.historyCondition['condition.fromDate'] = null;
      } else this.historyCondition['condition.fromDate'] = moment(new Date(dateStart)).format('YYYYMMDD');
      if (dateEnd == null) {
        this.historyCondition['condition.toDate'] = null;
      } else this.historyCondition['condition.toDate'] = moment(new Date(dateEnd)).format('YYYYMMDD');
    },

    onPageChanged(page) {
      this.currentPage = page;
      this.initHistory(this.IConstants.HISTORY_ENUMS.PAGE);
    },
    onPageJump(page, previous, next, maxVisibleButtons) {
      this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
      this.initHistory(this.IConstants.HISTORY_ENUMS.PAGE);
    },

    initHistory(mode) {
      this.formatDate(this.dateStart, this.dateEnd);
      let self = this;
      if (mode === true) {
        this.currentPage = 1;
      }

      this.$service.getService(this.IConstants.HISTORY_ENUMS.HISTORY_SERVICE).getListPaymentTransaction(this.currentPage, this.historyCondition)
          .then(response => {
            mode === this.IConstants.HISTORY_ENUMS.CANCEL ? self.model.listPaymentTransactionInfo = response.listPaymentTransactionInfo : self.model = response;
            if (response.pagingInfo != null) {
              self.totalPage = response.pagingInfo.totalPage === 0 ? 1 : response.pagingInfo.totalPage;
              self.totalItems = response.pagingInfo.total;
              self.offset = response.pagingInfo.offset;
            } else {
              self.totalItems = 0;
              self.offset = 10;
            }
          })
          .catch(error => {
            console.log(error);
          })
    },


    typeChange(e) {
      this.historyCondition['condition.transactionType'] = e;
      let typeSelect = e;
      let withdrawal = 1;
      let all = -1;

      if (typeSelect == withdrawal || typeSelect == all) {
        if (this.historyCondition['condition.transferStatus'] != '-1') {
          let valueInMapTransfer = this.$options.filters.getByPropertyName('key', this.historyCondition['condition.transferStatus'], this.mapTransferStatus).value;
          let comboxTransfer = this.$options.filters.getByPropertyName('value', valueInMapTransfer, this.mapDepositStatus);
          let keyFromText = comboxTransfer ? comboxTransfer.key : "-1";

          if (keyFromText !== null) {
            this.historyCondition['condition.status'] = keyFromText;
          }
          $("#dropdownMenuButtonDepositStatus").text(this.$i18n.t(comboxTransfer ? comboxTransfer.value : "default.combo.box"));
        }

        this.historyCondition['condition.transferStatus'] = '-1';
        this.isTypeChange = true;
      } else {
        if (this.historyCondition['condition.status'] != '-1') {
          let valueInMapDeposit = this.$options.filters.getByPropertyName('key', this.historyCondition['condition.status'], this.mapDepositStatus).value;
          let comboxDeposit = this.$options.filters.getByPropertyName('value', valueInMapDeposit, this.mapTransferStatus);
          let keyFromText = comboxDeposit ? comboxDeposit.key : null;

          if (keyFromText !== null) {
            this.historyCondition['condition.transferStatus'] = keyFromText;
          }
          $("#dropdownMenuButtonDepositStatus").text(this.$i18n.t(comboxDeposit ? comboxDeposit.value : "default.combo.box"));
        }

        this.historyCondition['condition.status'] = '-1';
        this.isTypeChange = false;
      }
    },

    exportCsv() {
      this.formatDate(this.dateStart, this.dateEnd);
      this.isDisabled = true;
      let self = this;
      this.$service.getService(this.IConstants.HISTORY_ENUMS.HISTORY_SERVICE).submitExportCondition(this.historyCondition)
          .then(res => {
            if (res.data.errorMessage == null) {
              self.model.errorMessage = null;
              window.location.href = `${domain}/${ROOT}/${HISTORY}/export-csv?token=${res.data.token}`;
            } else {
              self.model.errorMessage = res.data.errorMessage;
            }
            self.isDisabled = false;
          });
    },

    cancelWithdrawal(wid) {
      this.wid = wid;
      this.model.errorMessage = null;
      this.model.successMessage = null;
      let params = {
        messageText: 'confirm.cancel.transaction'
      };
      this.$modal.modalConfirm(params, this.IConstants.E_CONFIRM_SCREEN.HISTORY_CANCEL);
    },

    getModalConfirmResult() {
      let self = this;
      let confirm = 'ok';
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.HISTORY_CANCEL, (buttonClicked) => {
        if (buttonClicked && buttonClicked === confirm) {
          let params = new FormData();
          params.append("cancelInfo.withdrawalId", self.wid);
          self.$service.getService(self.WITHDRAWAL_SERVICE).withdrawalCancel(params).then((response) => {
            self.initHistory('cancel');
            if (response.successMessage != null) {
              self.model.errorMessage = null;
              self.model.successMessage = response.successMessage;
            } else {
              self.model.successMessage = null;
              self.model.errorMessage = response.errorMessage;
            }
            window.scrollTo(0, 0);
          }).catch((error) => {
            if (error.errorMessage != null) {
              self.model.errorMessage = error.errorMessage;
            }
            window.scrollTo(0, 0);
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.page-ct {
  min-height: 750px;
}

@media screen and (max-width: 767px) {
  #btnExportCsv, #btn-search {
    width: 100% !important;
  }

  .nopadding-right {
    padding-right: 0;
  }
}

@media screen and (min-width: 768px) {

  .nopadding-right {
    padding-right: 20px !important;
  }

  .btn-block {
    display: flex;
    margin-left: 10px !important;
  }
}

.btn:hover,
.btn:focus {
  text-decoration: none;
  color: #333333;
}

.btn-success, .btn-primary {
  border-width: 0 0 0 0;
}

.dropdown {
  width: 100%;
}

.btn.btn-block {
  font-size: 14px;
  width: 54px;
}

.box-filter .margintop {
  margin-top: 28px;
}

@media screen and (max-width: 767px) {
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > thead > tr > th {
    white-space: nowrap
  }
}
</style>
